module.exports = __webpack_public_path__ + "img/IMG_0057_L.692a3969.webp";